module.exports = __webpack_public_path__ + "img/tp.e56371e3.png";